import React from "react";
import img from "../../images/AVIZEAU-768x394.png";
import avatar from "../../images/Eva-roussel-262x300.jpg";
import thumbail from "../../images/sddefault.jpg";
import ReactPlayer from "react-player";
const MissionServiceAvizeau = () => {
  const list = [
    {
      id: 1,
      text: "Plus de tranquillité en évitant leur présence lors du relevé du compteur ;",
    },
    {
      id: 2,
      text: "Plus de transparence avec une facturation correspondant à la consommation réelle, et non plus à une estimation ;",
    },
    {
      id: 3,
      text: "Plus de sérénité avec la mise en place d’alertes en cas de fuite détectée chez l’abonné ;",
    },
    {
      id: 4,
      text: "Plus d’économies avec la possibilité de suivre leur consommation de manière plus régulière et une alerte en cas de dérive.",
    },
  ];
  return (
    <div className="container mx-auto mt-20 mb-20 md:px-40 sm:px-40">
      <div className="flex flex-col md:flex-row">
        <div>
          <br />
          <img src={img} alt="" className="w-80" />
          <p className="mt-3 font-bold text-justify">
            Mis en place pour améliorer la satisfaction de l’usager, Aviz’eau
            lui permet d’avoir ses consommations relevées à distance, d’être
            facturé en fonction de ses consommations réelles et non plus
            estimées, d’être alerté par e-mail, SMS ou courrier en cas de
            consommation anormale pouvant provenir de fuites et enfin de suivre
            sa consommation d’eau en direct par internet.
          </p>

          <div className="grid grid-cols-1 gap-5 mt-5 md:grid-cols-2 justify-items-center">
            <div id="part-1">
              <p className="text-justify">
                <span className="font-bold ">Aviz’eau</span> a pour objectif
                d’optimiser la relève des compteurs d’eau potable et d’améliorer
                notablement la qualité du service pour les abonnés en leur
                apportant notamment :
              </p>
              <ul className="ml-5 list-disc ">
                {list.map((item) => (
                  <div key={item.id}>
                    <li className="text-justify">{item.text}</li>
                  </div>
                ))}
              </ul>
            </div>
            <div>
              {" "}
              <div className="mt-32 md:mt-0 justify-items-end">
                <ReactPlayer
                  width={550}
                  playing={true}
                  url="https://www.youtube.com/watch?v=bVqgHUz3sgk"
                  light={
                    <img
                      src={thumbail}
                      alt="Thumbnail"
                      className="w-[500px] "
                    />
                  }
                />
              </div>
            </div>
            <div id="part-2">
              <p className="mt-4 font-bold text-justify">
                Comment fonctionne ce service ?
              </p>
              <p className="mt-2 text-justify">
                Un dispositif est posé sur le compteur. Il enregistre puis
                transmet par voie hertzienne le relevé du compteur à un
                récepteur. La durée d’une transmission est de l’ordre de
                quelques millisecondes pour un total de moins d’une seconde par
                jour. Le récepteur (l’antenne), situé en point haut, reçoit les
                données des compteurs.
              </p>
              <p className="mt-2 text-justify">
                Pour transmettre ces données au système informatique clientèle
                de la SEOP, le récepteur se connecte au réseau de téléphonie
                mobile pendant quelques secondes. Le cumul des périodes de
                transmission représente une durée maximale de quelques minutes
                de communication par jour.
              </p>
            </div>
            <div id="part-3">
              <p className="mt-4 text-justify">
                Quelles sont les conditions d’installation d’aviz’eau ?
              </p>
              <p className="text-justify">
                Les équipes de la SEOP se déplacent de quartier en quartier pour
                équiper les compteurs. Si le compteur est accessible depuis la
                voie publique, vous n’avez pas besoin de vous rendre disponible.
                A l’inverse s’il est non accessible, vous serez contacté par
                courrier pour fixer un rendez-vous.
              </p>
              <p className="mt-2 text-justify">
                Les équipes de la SEOP se déplacent de quartier en quartier pour
                équiper les compteurs. Si le compteur est accessible depuis la
                voie publique, vous n’avez pas besoin de vous rendre disponible.
                A l’inverse s’il est non accessible, vous serez contacté par
                courrier pour fixer un rendez-vous.
              </p>
            </div>
            <div id="part-4" className="mr-20">
              <p className="mt-4 text-justify">
                Quel est le coût de ce service ?
              </p>
              <p className="text-justify">
                Le prix du service aviz’eau est inclus dans le prix de l’eau
              </p>
            </div>

            <div>
              <p className="mt-2 text-justify">
                Dans le cas des habitats collectifs, les équipes de la SEOP
                prendront contact avec le gestionnaire de l’habitat (bailleur,
                syndic, conseil syndical) pour fixer un rendez-vous et équiper
                le compteur général de l’immeuble.
              </p>
            </div>

            <div id="part-6">
              <p className="mt-4 text-justify">
                Est-il possible de refuser le service ?
              </p>
              <p className="text-justify">
                Il est possible de refuser. Toutefois cela entraînera un surcoût
                lié au déplacement d’un agent afin d’effectuer la relève. Le
                prix est de 42,10 euros.
              </p>
            </div>

            <div id="part-5">
              <p className="mt-4 text-justify">
                Comment suivre ma consommation ?
              </p>
              <p className="text-justify">
                Pour activer ce nouveau service et être alerté par SMS ou par
                mail, l’usager doit compléter ses coordonnées dans l’espace «
                Mon compte en ligne » du site internet de la{" "}
                <span className="font-bold text-primary">SEOP.</span>
              </p>
              <p className="mt-2 text-justify">
                Dès que le service aviz’eau sera mis en service pour votre
                foyer, vous découvrirez la rubrique lui correspondant. Elle vous
                permettra de suivre l’évolution continue de votre consommation
                et le paramétrage personnalisé de votre alerte fuite et de vos
                seuils de consommation. Vous pourrez choisir comment être alerté
                en cas de fuite, et recevrez celles-ci automatiquement dès votre
                inscription.
              </p>
            </div>

            <div id="part-7">
              <p className="mt-4 font-bold text-justify text-primary">
                Deux alertes à votre service !
              </p>
              <p className="mt-4 font-bold text-justify">
                L’alerte surconsommation
              </p>
              <p className="text-justify">
                Vous fixez le seuil de consommation mensuelle que vous ne
                souhaitez pas dépasser. Un message d’alerte vous est envoyé
                lorsque ce seuil est franchi.
              </p>
            </div>

            <div id="part-8">
              <p className="font-bold text-justify mt-14">L’alerte fuite</p>
              <p className="text-justify">
                Un message d’alerte vous est envoyé lorsque la SEOP constate une
                consommation anormale pendant 5 jours consécutifs.
              </p>
            </div>
          </div>

          <div
            id="question"
            className="p-2 text-center border-2 mt-14 border-primary"
          >
            <p className="font-semibold">Pour toute question</p>
            <p className="font-bold">
              Contactez-nous au 0 977 409 436 (appel non surtaxé)
            </p>
            <p className="font-bold">
              Un conseiller est à votre écoute pour activer votre compte et
              mettre en place vos alertes.
            </p>
          </div>
          <div className="mt-4">
            <p className="font-semibold">Exemple</p>
            <div className="grid grid-cols-6 gap-2">
              <div className="mt-2">
                <img src={avatar} alt="" />
              </div>
              <div className="col-span-5">
                <p className="text-justify">
                  Un habitant de la commune de Villepreux a été alerté au mois
                  de février suite à une fuite à son domicile, il témoigne : «
                  J’ai bien été alerté par SMS, il s’agissait d’une fuite de
                  chasse d’eau. Heureusement que j’ai reçu l’alerte car il
                  s’agissait d’un sanitaire que nous n’utilisons pas et qui est
                  réservé aux invités. À la suite de l’alerte, j’ai pu inspecter
                  mon compteur, qui tournait effectivement très doucement mais
                  en continu ».
                </p>
                <p className="mt-2 text-justify">
                  Le client a reçu le SMS qui l’a renvoyé sur son compte en
                  ligne pour vérifier les données de sa consommation. L’usager a
                  ensuite réparé directement et rapidement sa fuit
                </p>
                <p className="mt-2 text-justify">
                  A la question : « Recommanderiez-vous ce dispositif ? », il
                  nous répond : « Oui, bien sûr. Et je ne comprends pas que
                  certains hésitent encore ».
                </p>
              </div>
            </div>
            <div className="mt-2 text-justify">
              <p>
                « Grâce à Aviz’eau, les usagers du territoire pourront être
                alertés en cas de fuite et ainsi éviter des désagréments autant
                matériels que financiers. Ce nouveau service permettra aussi de
                suivre sa consommation et d’être facturé plus justement, sans
                l’intervention d’un releveur. C’est donc un triple bénéfice pour
                l’usager ! »
              </p>
              <p className="mt-2 font-bold text-justify">
                Eva Roussel, conseillère communautaire de SQY et vice-présidente
                d’Aquavesc
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionServiceAvizeau;
